import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";

const BankForm = ({ mode, bankData, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    bank_id: "",
    name_bank: "",
    nomor_rekening: "",
    name_rekening: "",
    image: "",
  });
  const [imageOld, setImageOld] = useState("");
  
  useEffect(() => {
    if (mode === "edit" && bankData) {
      const { bank_id, name_bank, nomor_rekening, name_rekening, image_url} = bankData;
      setFormData({
        bank_id: bank_id || "",
        name_bank: name_bank || "",
        nomor_rekening: nomor_rekening || "",
        name_rekening: name_rekening || "",
        image: "",
      });
    setImageOld(image_url || "");
    } else {
      setFormData({
        bank_id: "",
        name_bank: "",
        nomor_rekening: "",
        name_rekening: "",
        image: "",
      });
      setImageOld("");
    }
  },[mode,bankData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file, // simpan objek File, bukan path
    });
  };  

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === "add") {
        const data = new FormData();
        data.append("name_bank", formData.name_bank);
        data.append("nomor_rekening", formData.nomor_rekening);
        data.append("name_rekening", formData.name_rekening);
        data.append("image", formData.image);

        const response = await axios.post(
          `${process.env.REACT_APP_API}/bank`,
          data,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
  
        if (response.status === 201) {
          showSuccess("Bank berhasil ditambahkan");
          closeModal();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal menambahkan bank");
        }

      } else {
        const updatedForm = new FormData();
        updatedForm.append("bank_id", formData.bank_id);
        updatedForm.append("name_bank", formData.name_bank);
        updatedForm.append("nomor_rekening", formData.nomor_rekening);
        updatedForm.append("name_rekening", formData.name_rekening);

        if (formData.image instanceof File) {
          updatedForm.append("image", formData.image);
          updatedForm.append("imageOld", imageOld);
        }     
  
        const response = await axios.put(
          `${process.env.REACT_APP_API}/bank/${formData.bank_id}`,
          updatedForm,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
  
        if (response.status === 200) {
          showSuccess("Bank berhasil diperbarui");
          closeModal();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal memperbarui bank");
        }
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
    }
  };

  return (        
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah Bank" : "Edit Bank"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div class="form-group mb-3">
            <label for="name_bank" class="form-label">Nama Bank</label>
            <input 
              class="form-control"
              type="text" 
              name="name_bank"
              placeholder="Isi Nama Bank"
              value={formData.name_bank}
              onChange={handleChange}
              required
            />
          </div>
          <div class="form-group mb-3">
            <label for="no_rekening" class="form-label">Nomor Rekening</label>
            <input 
              class="form-control"
              type="text" 
              name="nomor_rekening"
              placeholder="Isi Nomor Rekening"
              value={formData.nomor_rekening}
              onChange={handleChange}
              required
            />
          </div>
          <div class="form-group mb-3">
            <label for="name_rekening" class="form-label">Nama Rekening</label>
            <input 
              class="form-control"
              type="text" 
              name="name_rekening"
              placeholder="Isi Nama Rekening"
              value={formData.name_rekening}
              onChange={handleChange}
              required
            />
          </div>
          
          <div class="form-group mb-4">
            <label for="image" class="form-label">Image</label>
            <input
              type="file"
              className="form-control"
              id="image"
              name="image"
              onChange={handleFileChange}
              required={mode === "add"}
            />
          </div>

          <button type="submit" class="btn btn-primary">
            {mode === "add" ? "Save" : "Update"}
          </button>
        </form>
          
        </div>
      </div>
    </div>
  );
};

export default BankForm;
